module.exports = __webpack_public_path__ + "img/Bell_inActive.e125f47a.svg";